var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 9.66667C6.67683 7.968 6.7235 6.97733 6.50416 6.36667C6.45105 6.236 6.38016 6.11329 6.2935 6.002C5.7515 5.248 5.5055 4.65867 5.4115 4.294C5.35892 4.07931 5.33803 3.85807 5.3495 3.63733C5.38364 3.06191 5.58139 2.5082 5.9195 2.04133C6.48616 1.248 7.54216 1.00467 8.00016 1C8.45883 1.00467 9.54216 1.24867 10.1088 2.04133C10.4469 2.5082 10.6447 3.06191 10.6788 3.63733C10.6882 3.85733 10.6715 4.08067 10.6168 4.294C10.5235 4.65867 10.2768 5.24733 9.73483 6.002C9.64817 6.11329 9.57728 6.236 9.52416 6.36667C9.3055 6.97733 9.32416 7.968 9.66683 9.66667M9.3335 7.66667H6.66683M11.7782 13H4.22216C4.0155 13 3.91216 13 3.8275 12.9713C3.5975 12.8947 3.41816 12.67 3.35616 12.382C3.3335 12.2767 3.3335 12.148 3.3335 11.8893C3.3335 11.3727 3.3335 11.1147 3.37883 10.9027C3.50216 10.3273 3.8615 9.878 4.3215 9.724C4.4915 9.66667 4.69816 9.66667 5.1115 9.66667H10.8888C11.3022 9.66667 11.5088 9.66667 11.6788 9.72333C12.1388 9.87733 12.4982 10.3267 12.6215 10.902C12.6668 11.114 12.6668 11.372 12.6668 11.8887C12.6668 12.1473 12.6668 12.2767 12.6442 12.382C12.5822 12.67 12.4028 12.8947 12.1728 12.9713C12.0882 13 11.9848 13 11.7782 13Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15L13 15",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigio);
export default __webpack_public_path__ + "static/media/digio.96ab367c27824792af2f90e7bed12fc8.svg";
export { ForwardRef as ReactComponent };